import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=34465d83&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34465d83')) {
      api.createRecord('34465d83', component.options)
    } else {
      api.reload('34465d83', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=34465d83&", function () {
      api.rerender('34465d83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/Global/Form.vue"
export default component.exports